import script from "./UCLectorNFC.vue?vue&type=script&setup=true&lang=js"
export * from "./UCLectorNFC.vue?vue&type=script&setup=true&lang=js"

import "./UCLectorNFC.vue?vue&type=style&index=0&id=2ca01f1c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca01f1c"]])

export default __exports__